// extracted by mini-css-extract-plugin
export default {"section":"Footer_section__uOHBE"};